
<template>
    <div class="card disable-rounded-right mb-0 p-2 h-100 d-flex justify-content-center">
        <div class="card-header pb-1">
            <div class="card-title">
                <h4 class="text-center mb-2">{{ $t("message.login") }}</h4>
            </div>
        </div>
        <div class="card-content">
            <div class="card-body">
                <!--div class="d-flex flex-md-row flex-column justify-content-around">
                    <a href="#" class="btn btn-social btn-google btn-block font-small-3 mr-md-1 mb-md-0 mb-1">
                        <i><font-awesome-icon :icon="['fab', 'google']"/></i><span class="pl-50 d-block text-center">Google</span></a>
                    <a href="#" class="btn btn-social btn-block mt-0 btn-facebook font-small-3">
                        <i><font-awesome-icon :icon="['fab', 'facebook']"/></i><span class="pl-50 d-block text-center">Facebook</span></a>
                </div-->
                <div class="divider">
                    <div class="divider-text text-uppercase text-muted"><small>{{ $t("message.or_email_or_phone") }}</small>
                    </div>
                </div>
                <form>
                    <div :class="['form-group', 'mb-50', {error : validation.firstError('username')}]">
                        <div class="controls">
                            <label>{{ $t("message.email_or_phone") }}</label>
                            <input type="text" class="form-control" v-model="username"/>
                            <div class="help-block">{{ validation.firstError('username') }}</div>
                        </div> 
                    </div> 
                    <div :class="['form-group', 'mb-50', {error : validation.firstError('password')}]">
                        <div class="controls">
                            <label>{{ $t("message.password") }}</label>
                            <input type="password" class="form-control" v-model="password"/>
                            <div class="help-block">{{ validation.firstError('password') }}</div>
                        </div> 
                    </div>   
                    <div class="form-group ">
                        <div class="text-left">
                            <!--div class="checkbox checkbox-sm">
                                <input type="checkbox" class="form-check-input" :value = "true" v-model="keep_logged" id="keep_logged">
                                <label class="checkboxsmall" for="keep_logged"><small>{{ $t("message.logged_in") }}</small></label>
                            </div-->
                        </div>
                        <div class="text-right"><router-link  :to="{path:'/password-reset'}"><small>{{ $t("message.forgot_password") }}</small></router-link></div>
                        
                    </div>
                    <button type="submit" class="btn btn-primary glow w-100 position-relative" @click.prevent="login">{{ $t("message.login") }}<i id="icon-arrow"><font-awesome-icon :icon="['fas', 'arrow-right']"/></i></button>
                </form>
                <hr>
                <router-link style="position: relative;" class="btn btn-primary btn-block"  :to="{path:'/activate-by-serial'}">{{ $t("message.activate_by_serial")}}<i id="icon-arrow"><font-awesome-icon :icon="['fas', 'arrow-right']"/></i></router-link>
                
            </div>
        </div>
    </div> 
</template>

<script>
    //import Vue from 'vue';
    //import GAuth from 'vue-google-oauth2'
    //Vue.use(GAuth, {clientId: '238332010372-9p70ko2l4jdnrbgapdd6s5kd3ecstitg.apps.googleusercontent.com',scope: 'profile email'})
    import Validator from '@/formValidator';
    import globalSettings from '@/config.js'
    import axios from 'axios';
    export default{
        name: 'login_form',
        data() {
            return{
                title: 'Login form',
                username: null,
                password: null,
            }
        },
        
        validators: {
            username: function (value) {
                return Validator.value(value).required().minLength(4);
            },
            password: function (value) {
                return Validator.value(value).required().minLength(6);
            }
        },
        methods: {
            login: function () {
                 this.$validate().then(valid => {
                    if (valid) {
                        const {username, password} = this
                        this.$store.dispatch('auth_request', {username, password})
                                .then(() => {
                                    this.$store.dispatch('init').then(()=>{
                                         this.$router.push({path:"/"});
                                    })
                                })
                                .catch(() => {
                                   this.$store.dispatch('set_alert',{type:'danger', text:this.$t('message.bad_login_or_password')})
                                })
                    }
                });

            },
            google_auth:function(){
                this.$gAuth.getAuthCode()
                    .then(authCode => {
                        axios.get(globalSettings.api_url + 'oauth/google?code='+authCode)  
                            .then(response => {     
                            console.log(response);
                          })
                    .catch(error => {
                            console.log(error);
                    })
                    })
                    

            },
            
            
            
        }
    }
</script>

  
            

            